import { render, staticRenderFns } from "./PensionSummaryDashboardItem.vue?vue&type=template&id=25f92e4b&scoped=true"
import script from "./PensionSummaryDashboardItem.vue?vue&type=script&lang=js"
export * from "./PensionSummaryDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./PensionSummaryDashboardItem.vue?vue&type=style&index=0&id=25f92e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f92e4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VDataTable,VExpandTransition,VIcon,VProgressCircular,VRow,VTooltip})
